import {Account} from "@/entities/auth/Account";
import {Voting} from "@/entities/voting/Voting";
import {Branch} from "@/entities/Branch";
import {VotingType} from "@/entities/voting/VotingType";
import {VotingResult} from "@/entities/voting/VotingResult";
import {VotesType} from "@/entities/voting/VotesType";
import {VotingStatus} from "@/entities/voting/VotingStatus";

export class ToolVotingDetail extends Voting {
    newTool: {id: number, name: string}

    constructor(id: number, name: string, branch: Branch, type: VotingType, status: VotingStatus, votes: VotingResult, initiator: Account, currentVote: VotesType, newTool: { id: number; name: string }) {
        super(id, name, branch, type, status, votes, initiator, currentVote);
        this.newTool = newTool;
    }

    static createVotingDetail(obj: any) {
        const voting = Voting.createVoting(obj);
        const newTool = {id: obj.newTool.id, name: obj.newTool.name};

        return new ToolVotingDetail(voting.id, voting.name, voting.branch, voting.type, voting.status, voting.votes, voting.initiator, voting.currentVote, newTool);
    }
}
